import { render, staticRenderFns } from "./BrokerWizard.vue?vue&type=template&id=28ecb79a"
import script from "./BrokerWizard.vue?vue&type=script&lang=js"
export * from "./BrokerWizard.vue?vue&type=script&lang=js"
import style0 from "./BrokerWizard.vue?vue&type=style&index=0&id=28ecb79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports